import { render, staticRenderFns } from "./EditBackgroundEvent.vue?vue&type=template&id=34e9b4c2"
import script from "./EditBackgroundEvent.vue?vue&type=script&lang=js"
export * from "./EditBackgroundEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports